<template>
  <div class="text-xs-center">
    <v-dialog :value="value" @input="$emit('input')" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2 py-0" primary-title>
          Setar Tag
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <v-btn flat fab small icon @click="$emit('input')" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Cancelar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn
              color="primary"
              fab
              dark
              small
              @click="adiciona"
              :loading="loading"
              slot="activator"
            >
              <v-icon>done</v-icon>
            </v-btn>
            <span>Salvar</span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            v-model="tag"
            :items="tagsAtivo"
            item-text="Descricao"
            return-object
            menu-props="auto"
            label="Tag"
            hide-details
            prepend-icon="label"
            class="mb-3"
            auto-select-first
            no-data-text="Registro não encontrado."
          ></v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  props: ["value", "atividadeTag", "loading"],
  data() {
    return {
      tag: null
    };
  },
  methods: {
    ...mapMutations(["showNotification"]),
    ...mapActions(["fetchTags"]),
    adiciona() {
      if (this.tag) {
        if (this.atividadeTag !== null) {
          this.atividadeTag.IdTag = this.tag.IdTag;
          this.atividadeTag.Descricao = this.tag.Descricao;
          this.$emit("setaTag", this.atividadeTag);
          this.tag = null;
        } else {
          this.$emit("setaTagSelected", this.tag);
          this.tag = null;
        }
      } else {
        this.showNotification({ text: "Informe a tag", status: 'error' });
      }
    }
  },
  computed: {
    ...mapGetters(["tagsAtivo"])
  },
  async created() {
    if (!this.tagsAtivo.length) {
      await this.fetchTags();
    }
  }
};
</script>

<style>
</style>
